import { CLOUDER_SERVICES, ROUTE_TYPES } from '@wareclouds/frontend-common/b2c';
import EnabledRoutes from '../EnabledRoutes';
import { useTranslation } from 'react-i18next';

export default function useGetTabItems() {
  const { t } = useTranslation(['description']);

  return [
    {
      id: 'crossdocking',
      label: t('routes.enabled.crossdocking'),
      serviceId: CLOUDER_SERVICES.CROSSDOCKING,
      component: EnabledRoutes,
      routeType: ROUTE_TYPES.CROSSDOCKING,
    },
    {
      id: 'same_day',
      label: t('routes.enabled.same_day'),
      serviceId: CLOUDER_SERVICES.SAME_DAY,
      component: EnabledRoutes,
      routeType: ROUTE_TYPES.SAME_DAY,
    },
    {
      id: 'express_scheduled',
      label: t('routes.enabled.express_scheduled'),
      serviceId: CLOUDER_SERVICES.EXPRESS_SCHEDULED,
      component: EnabledRoutes,
      routeType: ROUTE_TYPES.EXPRESS_SCHEDULED,
    },
    {
      id: 'express',
      label: t('routes.enabled.express'),
      serviceId: CLOUDER_SERVICES.EXPRESS,
      component: EnabledRoutes,
      routeType: ROUTE_TYPES.EXPRESS,
    },
  ];
}
